import { Injectable } from '@angular/core';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';
import { RequiredUserActionHolder } from 'src/app/_services/user-action-validator/required-user-action-validator.service';
import { ObjectIdLabelDaoService } from '../object-id-label-dao.service';
import { ObjectIdLabelEntry } from '../../logic/object-id-label.service';
import { IMSObjectType } from 'src/app/_model/ims-object';

// CONSTANTS
enum OBJECT_ID_LABELS_KEYS {
  SERVICEJOB = 'object-id-labels-servicejob',
  BRANCH = 'object-id-labels-branch',
}

@Injectable()
export class ObjectIdLabelStorageDaoService
  implements ObjectIdLabelDaoService
{
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  public saveObjectIdLabelsData(
    objectIdLabelsData: ObjectIdLabelEntry[],
    objRef: IMSObjectType
  ): Promise<void> {
    return this.keyValueStorage.store(
      this.getKeyForObjRef(objRef),
      objectIdLabelsData,
    );
  }
  public getObjectIdLabelsData(objRef: IMSObjectType): Promise<ObjectIdLabelEntry[]> {
    return this.keyValueStorage.load(this.getKeyForObjRef(objRef));
  }

  public async reset() {}

  public async clear() {
    for (const key of Object.values(OBJECT_ID_LABELS_KEYS)) {
      await this.keyValueStorage.delete(key);
    }
  }

  private getKeyForObjRef(objRef: IMSObjectType): string {
    switch (objRef) {
      case 'ims/ServiceJob':
        return OBJECT_ID_LABELS_KEYS.SERVICEJOB;
      case 'ims/Branch':
        return OBJECT_ID_LABELS_KEYS.BRANCH;
      default:
        throw new Error(`Unsupported Object Reference: ${objRef}`);
    }
  }
}
